import useViewport from "components/UseViewport/UseViewport";
import { Typography, Timeline, Card, Image, Button, Space, Divider } from "antd";
import colors from "constants/colors";
import blHeads from "assets/images/timelineImages/bl_faces.png";
import { timelineEvents } from "./constants";

const { Title } = Typography;

const BLTimeline = () => {
  const { width } = useViewport();
  const breakpoint = 900;

  return (
    <>
      <Space direction="horizontal" style={{ width: "100%", justifyContent: "center" }}>
        <Title>Vår historie</Title>
      </Space>
      <Divider />

      <Card>
        <Timeline mode={width > breakpoint ? "alternate" : "left"}>
          {timelineEvents.map(timelineEvent => (
            <Timeline.Item
              key={timelineEvent.title}
              label={
                width > breakpoint ? (
                  <Title level={5} style={{ margin: "0 10px" }}>
                    {timelineEvent.year}
                  </Title>
                ) : null
              }
              dot={
                <Image
                  src={blHeads}
                  preview={false}
                  style={{ width: "30px", borderRadius: "15px", backgroundColor: colors.primary }}
                />
              }
              color={colors.primary}
            >
              <Card
                title={
                  <div style={{ whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word" }}>
                    {timelineEvent.title}
                  </div>
                }
                style={{
                  backgroundColor: "var(--neutral-alt)",
                  marginRight: "7px",
                }}
              >
                {timelineEvent.description}
                <>
                  {timelineEvent.img ? (
                    <Image
                      style={{ margin: "20px 0", borderRadius: "5px" }}
                      width="100%"
                      preview={false}
                      src={timelineEvent.img}
                      alt={timelineEvent.title}
                    />
                  ) : null}
                </>
                <>
                  {timelineEvent.btnTxt ? (
                    <Button
                      size="large"
                      type="primary"
                      href={timelineEvent.btnLink}
                      style={{ margin: "20px 0", padding: "20px", width: "100%" }}
                    >
                      {timelineEvent.btnTxt}
                    </Button>
                  ) : null}
                </>
                {width <= breakpoint ? (
                  <Title level={5} italic>
                    {timelineEvent.year}
                  </Title>
                ) : null}
              </Card>
            </Timeline.Item>
          ))}
        </Timeline>
      </Card>
    </>
  );
};

export default BLTimeline;
